<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal
        :show.sync="modals.successModal"
        :message="message"
        :title="title"
      />
      <StatusModal
        :show.sync="modals.removeModal"
        :message="message"
        :title="title"
      />

      <modal :show.sync="modals.submit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>{{ title }}</h1>
            <p>
              {{ message }}
            </p>
          </div>
        </div>
      </modal>
      <!-- <modal :show.sync="modals.warningsubmit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">Please fill in all the forms.</div>
        </div>
      </modal> -->

      <!-- view / edit -->
      <div v-if="$route.params.action == 'edit'">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                OPERATION PHOTOS
              </p>
              <div style="height: 720px; overflow: auto; overflow-x: hidden">
               
                <div class="row">
                  <div class="col-lg">
                    
                    <card class="card-eprf">
                    
                     
                      <div class="body">
                        <!-- pre operatio -->
                        <div class="row" style="line-height: 1px">
                          <div class="col-lg">
                            <p
                              style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              "
                            >
                              Pre-operation <span style="color: #EC1B23">*</span>
                            </p>
                          </div>
                        </div>

                        <div class="row" v-if="displayflag">
                          <div class="col-lg">
                            <p style="font-size: 14px; color: #aaaaaa">
                              Please upload related photo(s)
                            </p>
                          </div>
                        </div>
                        <div
                          style="
                            height: 110px;
                            overflow: auto;
                            overflow-x: hidden;
                          "
                        >
                          <div
                            class="row"
                            style="padding-bottom: 5px; padding-top: 5px"
                          >
                            <div class="col-lg-3" v-if="displayflag">
                              <label for="pre">
                                <img
                                  src="@/assets/img/upload.png"
                                  width="73"
                                  height="45"
                                />
                              </label>
                              <input
                                accept="image/*"
                                type="file"
                                name="..."
                                id="pre"
                                ref="pre"
                                @change="onprechange($event, 0)"
                                :multiple="false"
                                style="display: none"
                              />
                            </div>
                            <div
                              class="col-lg-3"
                              v-for="(item, index) in preoperation"
                              :key="index"
                              style="padding-bottom: 5px"
                            >
                              <img :src="item.fileurl" width="73" height="45" />
                              <div
                                style="position: absolute; right: 20%; top: 0"
                              >
                                <base-button
                                  v-if="displayflag"
                                  class="btn-icon btn-cancel btn-round btn-xs"
                                  @click="deleteimage(item.fileid)"
                                  ><i class="fa fa-times" aria-hidden="true"></i
                                ></base-button>
                                <br />

                                <a :href="item.fileurl">
                                  <base-button
                                    class="btn-icon btn-primary btn-round btn-xs"
                                    ><i
                                      class="fa fa-arrow-down"
                                      aria-hidden="true"
                                    ></i
                                  ></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <!-- during operation -->
                        <div class="row" style="line-height: 1px">
                          <div class="col-lg">
                            <p
                              style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              "
                            >
                              During operation <span style="color: #EC1B23">*</span>
                            </p>
                          </div>
                        </div>
                        <div class="row" v-if="displayflag">
                          <div class="col-lg">
                            <p style="font-size: 14px; color: #aaaaaa">
                              Please upload related photo(s)
                            </p>
                          </div>
                        </div>
                        <div
                          style="
                            height: 110px;
                            overflow: auto;
                            overflow-x: hidden;
                          "
                        >
                          <div
                            class="row"
                            style="padding-bottom: 5px; padding-top: 5px"
                          >
                            <div class="col-lg-3" v-if="displayflag">
                              <label for="during">
                                <img
                                  src="@/assets/img/upload.png"
                                  width="73"
                                  height="45"
                                />
                              </label>
                              <input
                                accept="image/*"
                                type="file"
                                name="..."
                                id="during"
                                ref="during"
                                @change="onprechange($event, 1)"
                                :multiple="false"
                                style="display: none"
                              />
                            </div>
                            <div
                              class="col-lg-3"
                              v-for="(item, index) in duringoperation"
                              :key="index"
                              style="padding-bottom: 5px"
                            >
                              <img :src="item.fileurl" width="73" height="45" />
                              <div
                                style="position: absolute; right: 20%; top: 0"
                              >
                                <base-button
                                  v-if="displayflag"
                                  class="btn-icon btn-cancel btn-round btn-xs"
                                  @click="deleteimage(item.fileid)"
                                  ><i class="fa fa-times" aria-hidden="true"></i
                                ></base-button>
                                <br />

                                <a :href="item.fileurl">
                                  <base-button
                                    class="btn-icon btn-primary btn-round btn-xs"
                                    ><i
                                      class="fa fa-arrow-down"
                                      aria-hidden="true"
                                    ></i
                                  ></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <!-- post operation -->
                        <div class="row" style="line-height: 1px">
                          <div class="col-lg">
                            <p
                              style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              "
                            >
                              Post-operation <span style="color: #EC1B23">*</span>
                            </p>
                          </div>
                        </div>
                        <div class="row" v-if="displayflag">
                          <div class="col-lg">
                            <p style="font-size: 14px; color: #aaaaaa">
                              Please upload related photo(s)
                            </p>
                          </div>
                        </div>
                        <div
                          style="
                            height: 110px;
                            overflow: auto;
                            overflow-x: hidden;
                          "
                        >
                          <div
                            class="row"
                            style="padding-bottom: 5px; padding-top: 5px"
                          >
                            <div class="col-lg-3" v-if="displayflag">
                              <label for="post">
                                <img
                                  src="@/assets/img/upload.png"
                                  width="73"
                                  height="45"
                                />
                              </label>
                              <input
                                accept="image/*"
                                type="file"
                                name="..."
                                id="post"
                                ref="post"
                                @change="onprechange($event, 2)"
                                :multiple="false"
                                style="display: none"
                              />
                            </div>
                            <div
                              class="col-lg-3"
                              v-for="(item, index) in postoperation"
                              :key="index"
                              style="padding-bottom: 5px"
                            >
                              <img :src="item.fileurl" width="73" height="45" />
                              <div
                                style="position: absolute; right: 20%; top: 0"
                              >
                                <base-button
                                  v-if="displayflag"
                                  class="btn-icon btn-cancel btn-round btn-xs"
                                  @click="deleteimage(item.fileid)"
                                  ><i class="fa fa-times" aria-hidden="true"></i
                                ></base-button>
                                <br />

                                <a :href="item.fileurl">
                                  <base-button
                                    class="btn-icon btn-primary btn-round btn-xs"
                                    ><i
                                      class="fa fa-arrow-down"
                                      aria-hidden="true"
                                    ></i
                                  ></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <!-- inspection operation -->
                        <div class="row" style="line-height: 1px">
                          <div class="col-lg">
                            <p
                              style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              "
                            >
                              Inspection Photo <span style="color: #EC1B23">*</span>
                            </p>
                          </div>
                        </div>
                        <div class="row" v-if="displayflag">
                          <div class="col-lg">
                            <p style="font-size: 14px; color: #aaaaaa">
                              Please upload related photo(s)
                            </p>
                          </div>
                        </div>
                        <div
                          style="
                            height: 110px;
                            overflow: auto;
                            overflow-x: hidden;
                          "
                        >
                          <div
                            class="row"
                            style="padding-bottom: 5px; padding-top: 5px"
                          >
                            <div class="col-lg-3" v-if="displayflag">
                              <label for="ins">
                                <img
                                  src="@/assets/img/upload.png"
                                  width="73"
                                  height="45"
                                />
                              </label>
                              <input
                                accept="image/*"
                                type="file"
                                name="..."
                                id="ins"
                                ref="ins"
                                @change="onprechange($event, 3)"
                                :multiple="false"
                                style="display: none"
                              />
                            </div>
                            <div
                              class="col-lg-3"
                              v-for="(item, index) in inspection"
                              :key="index"
                              style="padding-bottom: 5px"
                            >
                              <img :src="item.fileurl" width="73" height="45" />
                              <div
                                style="position: absolute; right: 20%; top: 0"
                              >
                                <base-button
                                  v-if="displayflag"
                                  class="btn-icon btn-cancel btn-round btn-xs"
                                  @click="deleteimage(item.fileid)"
                                  ><i class="fa fa-times" aria-hidden="true"></i
                                ></base-button>
                                <br />

                                <a :href="item.fileurl">
                                  <base-button
                                    class="btn-icon btn-primary btn-round btn-xs"
                                    ><i
                                      class="fa fa-arrow-down"
                                      aria-hidden="true"
                                    ></i
                                  ></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />

                        <!-- other photo -->
                        <div class="row" style="line-height: 1px">
                          <div class="col-lg">
                            <p
                              style="
                                text-align: left;
                                font-size: 17px;
                                color: #707070;
                                font-weight: 600;
                              "
                            >
                              Other operation
                            </p>
                          </div>
                        </div>
                        <div class="row" v-if="displayflag">
                          <div class="col-lg">
                            <p style="font-size: 14px; color: #aaaaaa">
                              Please upload related photo(s)
                            </p>
                          </div>
                        </div>
                        <div
                          style="
                            height: 110px;
                            overflow: auto;
                            overflow-x: hidden;
                          "
                        >
                          <div
                            class="row"
                            style="padding-bottom: 5px; padding-top: 5px"
                          >
                            <div class="col-lg-3" v-if="displayflag">
                              <label for="other">
                                <img
                                  src="@/assets/img/upload.png"
                                  width="73"
                                  height="45"
                                />
                              </label>
                              <input
                                accept="image/*"
                                type="file"
                                name="..."
                                id="other"
                                ref="other"
                                @change="onprechange($event, 4)"
                                :multiple="false"
                                style="display: none"
                              />
                            </div>
                            <div
                              class="col-lg-3"
                              v-for="(item, index) in other"
                              :key="index"
                              style="padding-bottom: 5px"
                            >
                              <img :src="item.fileurl" width="73" height="45" />
                              <div
                                style="position: absolute; right: 20%; top: 0"
                              >
                                <base-button
                                  v-if="displayflag"
                                  class="btn-icon btn-cancel btn-round btn-xs"
                                  @click="deleteimage(item.fileid)"
                                  ><i class="fa fa-times" aria-hidden="true"></i
                                ></base-button>
                                <br />

                                <a :href="item.fileurl">
                                  <base-button
                                    class="btn-icon btn-primary btn-round btn-xs"
                                    ><i
                                      class="fa fa-arrow-down"
                                      aria-hidden="true"
                                    ></i
                                  ></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </card>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <div class="col-lg"></div>
        </div>
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <base-button type="danger" v-on:click="prevTab()">Back</base-button
            >&nbsp;
            <base-button
              type="primary"
              v-on:click="nextTab()"
              v-if="!displayflag"
              >Next</base-button
            >
            &nbsp;
            <base-button
              type="primary"
              v-on:click="submitdoc()"
              v-if="displayflag"
              :disabled="dis"
              >Submit</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  // props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    Modal,
    BCard,
  },

  data() {
    return {
      // general
      uploadload: false,
      positionid: "",
      status: "",
      displayflag: false,
      // modals
      title: "",
      message: "",

      // picture
      preoperation: [],
      duringoperation: [],
      postoperation: [],
      inspection: [],
      other: [],

      modals: {
        submit: false,
        warningsubmit: false,
        supportdoc: false,
        successModal: false,
        removeModal: false,
      },
      dis: false
    };
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );

    if (this.$route.params.action == "edit") {
      this.getData();
    }
  },
  mounted() {},
  computed: {},
  watch: {
    positionid() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    preoperation(){
      if(this.preoperation.length != 0 && this.duringoperation.length != 0 && this.postoperation.length != 0 && this.inspection.length != 0 ){
        this.dis = false
      } else {
        this.dis = true
      }
    },
    duringoperation(){
      if(this.preoperation.length != 0 && this.duringoperation.length != 0 && this.postoperation.length != 0 && this.inspection.length != 0  ){
        this.dis = false
      } else {
        this.dis = true
      }
    },
    postoperation(){
      if(this.preoperation.length != 0 && this.duringoperation.length != 0 && this.postoperation.length != 0 && this.inspection.length != 0 ){
        this.dis = false
      } else {
        this.dis = true
      }
    },
    inspection(){
      if(this.preoperation.length != 0 && this.duringoperation.length != 0 && this.postoperation.length != 0 && this.inspection.length != 0 ){
        this.dis = false
      } else {
        this.dis = true
      }
    },
    other(){
      if(this.preoperation.length != 0 && this.duringoperation.length != 0 && this.postoperation.length != 0 && this.inspection.length != 0 ){
        this.dis = false
      } else {
        this.dis = true
      }
    }
  },

  methods: {
    submitdoc() {
      this.$http
        .post(":10001/api/v1/outgoing/waste/"+ this.$route.params.jobnum+"/operation_photo/submit")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.nextTab()
          }
        });
    },
    deleteimage(imageid) {
      console.log("deeee");
      this.$http
        .delete(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/operation-photo/" +
            imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;
            this.$refs.pre.value = ""
            this.$refs.during.value = ""
            this.$refs.post.value = ""
            this.$refs.ins.value = ""
            this.$refs.other.value = ""
            this.getData();
          }
        });
    },
    onprechange(e, index) {
      console.log(index);
      const t = e.target;
      const formData = new FormData();
      console.log(t.files[0]);

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/operation-photo?index=" +
            index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Image successfully uploaded.";
            this.modals.successModal = true;
            this.getData();
          }
        });
      //   }
    },

    redirect() {
      this.$router.push("/Outgoing");
    },

    getData() {
      this.load = true;
      this.preoperation = [];
      this.duringoperation = [];
      this.postoperation = [];
      this.inspection = [];
      this.other = [];

      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.status = response.status.status;

            // get pre operation photo
            for (var i = 0; i < response.operation_photo.length; i++) {
              if (response.operation_photo[i].index == 0) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.preoperation.push(obj);
              } else if (response.operation_photo[i].index == 1) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.duringoperation.push(obj);
              } else if (response.operation_photo[i].index == 2) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.postoperation.push(obj);
              } else if (response.operation_photo[i].index == 3) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.inspection.push(obj);
              } else if (response.operation_photo[i].index == 4) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.other.push(obj);
              }
            }
          }
        });
    },

    prevTab() {
      // this.$router.push("/Outgoing");
      let parameter = {
        step: "5",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "5",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
      // this.validateStep('step2')
    },
  },
};
</script>
<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limit the number of lines to 3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  /* height: 20px; */
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.custom-dropdown-2 {
  width: 300px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

/* Add this CSS to your stylesheet */
.custom-table .el-table__body-wrapper {
  overflow-y: scroll;
  /* Ensure there is a vertical scrollbar */
}

/* Webkit browsers (Chrome, Safari) */
.custom-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
  /* Set the width of the scrollbar */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #358dcc;
  /* Set the color of the scrollbar thumb */
  border-radius: 6px;
  /* Set the border radius of the scrollbar thumb */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Set the color of the scrollbar track */
}

.custom-input {
  padding: 5px 5px 5px 5px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}
</style>
